import { useMemo } from 'react';

export const getAccountOptions = (accounts, isAccountsFlatList) => {
  return isAccountsFlatList
    ? getAccountOptionsFlatList(accounts)
    : getAccountOptionsHierarchical(accounts);
};

const getAccountOptionsFlatList = (accounts) => {
  const getAccountLevelPrefix = (level) => {
    if (level === 'A')
      return 'GP';
    else if (level === 'B') {
      return 'P';
    }
    return 'C';
  };
  
  return useMemo(() => {
    return accounts
      .map(item => {
        return {
          label: getAccountLevelPrefix(item.level) + ' - ' + item.contractName + ' - ' + item.contractNumber,
          value: item.contractNumber,
        };
      });
  }, [accounts]);
};

const getAccountOptionsHierarchical = (accounts) => {
  const getOption = (item) => {
    const children = groupDescendants(item.contractNumber);
    return {
      label: item.contractName + ' - ' + item.contractNumber,
      value: children.length > 0 ? children : item.contractNumber,
    };
  };

  const groupDescendants = (parentId = '') =>{
    return accounts
      .filter(item => item.parent === parentId)
      .map(item => getOption(item));
  };

  return useMemo(() => {
    const results = [];
    const rootAccounts = accounts.filter(account => !accounts.map(a => a.contractNumber).includes(account.parent));

    rootAccounts.forEach((item) => {
      results.push(getOption(item));
    });

    return results;
  }, [accounts]);
};
